module.exports = __webpack_public_path__ + "static/media/ico_shorttext.cb4665a8.svg";